import { render } from "./LoadingSkeletonDefault.vue?vue&type=template&id=29df6b56&ts=true"
import script from "./LoadingSkeletonDefault.vue?vue&type=script&lang=ts"
export * from "./LoadingSkeletonDefault.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__